import { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [privacy, setPrivacy] = useState(false);
  const [website, setWebsite] = useState('');
  const [status, setStatus] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus(null);
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Bitte gib eine gültige E-Mail-Adresse ein.');
      return;
    }
    if (!privacy) {
      setError('Bitte bestätige die Datenschutzerklärung.');
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email, datenschutz: privacy, website });
      setStatus(res.data.message);
      setEmail('');
      setPrivacy(false);
    } catch (err) {
      setError('Die Anmeldung ist leider fehlgeschlagen. Bitte versuche es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} noValidate className="mx-auto mt-8 max-w-xl" data-testid="newsletter-form">
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex-1">
          <label htmlFor="newsletter-email" className="mb-2 block text-sm font-semibold text-brand-cream">
            E-Mail-Adresse
          </label>
          <input
            id="newsletter-email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            aria-invalid={Boolean(error)}
            aria-describedby={error ? 'newsletter-error' : undefined}
            className="min-h-12 w-full rounded-sm border border-brand-cream/40 bg-white px-4 text-brand-brown"
            data-testid="newsletter-email-input"
          />
        </div>
        <div className="flex items-end">
          <button type="submit" disabled={loading} className="btn-primary min-h-12 w-full disabled:opacity-60 sm:w-auto" data-testid="newsletter-submit-button">
            {loading ? 'Wird angemeldet …' : 'Anmelden'}
          </button>
        </div>
      </div>
      <div aria-hidden="true" className="absolute -left-[9999px] h-0 w-0 overflow-hidden">
        <label htmlFor="newsletter-website">Website (bitte frei lassen)</label>
        <input id="newsletter-website" type="text" tabIndex={-1} autoComplete="off" value={website} onChange={(e) => setWebsite(e.target.value)} />
      </div>
      <div className="mt-4 flex items-start gap-3">
        <input
          id="newsletter-privacy"
          type="checkbox"
          checked={privacy}
          onChange={(e) => setPrivacy(e.target.checked)}
          className="mt-1 h-5 w-5 shrink-0 accent-brand-olive"
          data-testid="newsletter-privacy-checkbox"
        />
        <label htmlFor="newsletter-privacy" className="text-sm text-brand-cream/85">
          Ich habe die <a href="/datenschutz" className="font-semibold underline underline-offset-4 hover:text-white">Datenschutzerklärung</a> gelesen und bin mit der Verarbeitung meiner E-Mail-Adresse für den Newsletter einverstanden.
        </label>
      </div>
      {error && (
        <p id="newsletter-error" role="alert" className="mt-4 rounded-sm bg-white px-4 py-3 text-sm font-semibold text-red-800" data-testid="newsletter-error">
          {error}
        </p>
      )}
      {status && (
        <p role="status" className="mt-4 rounded-sm bg-white px-4 py-3 text-sm font-semibold text-brand-olive" data-testid="newsletter-success">
          {status}
        </p>
      )}
    </form>
  );
}
